export default __webpack_public_path__ + "static/media/Aura-Egg__18.7f91ae81.png";